export default "__VITE_ASSET__078d98d1__"